module.exports = __webpack_public_path__ + "img/yl_04.58ce3c64.png";